import $ from 'jquery'

var navScroll = function () {

    // Hide Header on on scroll down
    var didScroll;
    var lastScrollTop = 0;
    var cogLastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $('.header').outerHeight();
    var theta = 0;

    //****** Cog scroll for home page ******/
    function cogScroll() {

        // var beta = $(window).scrollTop() / 50 % Math.PI;

        var cogSt = $(window).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(cogLastScrollTop - cogSt) <= delta)
            return;

        if (cogSt > cogLastScrollTop) {
            // Scroll Down
            theta += 15;

            $('.cog__large').css({ transform: 'rotate(' + theta + 'deg)' });
            $('.cog__small').css({ transform: 'rotate(-' + theta + 'deg)' });
        } else {
            // Scroll Up
            theta -= 15;
            if (cogSt + $(window).height() < $(document).height()) {
                $('.cog__large').css({ transform: 'rotate(-' + theta + 'deg)' });
                $('.cog__small').css({ transform: 'rotate(' + theta + 'deg)' });
            }
        }
        cogLastScrollTop = cogSt;
    }


    //****** Nav Scroll function  ******/
    function hasScrolled() {

        var st = $(window).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta)
            return;
        if (st == 0 && $('.body-wrapper__home').length == null) {
            $('.header').removeClass('nav-up').addClass('nav-down');
        }

        if (st > lastScrollTop && st > navbarHeight) {
            // Scroll Down
            $('.header').removeClass('nav-down').addClass('nav-up');
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                $('.header').removeClass('nav-up').addClass('nav-down');
            }
        }
        lastScrollTop = st;
    }

    function chooseMenu() {
        if ($(window).width() > 1040 && $(window).scrollTop() <= $(window).height() / 2 && $('.body-wrapper__home').length) {
            $('.header').addClass('sub-active');
        }
        else {
            $('.header').removeClass('sub-active');
            return;
        }
    }

    function scrollEnd() {
        var scrollHeight = $(document).height();
        var scrollPosition = $(window).height() + $(window).scrollTop();
        if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
            $('.header').removeClass('nav-down').addClass('nav-up');
        }
    }

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    $(window).scroll(function (e) {
        didScroll = true;

        if ($('.body-wrapper__home').length) {
            chooseMenu();
            cogScroll();
        }

        scrollEnd();
    });

}


module.exports = navScroll;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/navscroll.js